// extracted by mini-css-extract-plugin
export var bgDark = "contactDetails-module--bgDark--zVwHf";
export var details = "contactDetails-module--details--LEnVK";